import { IImage } from "../models/image.model";

export const getDataImage = (image: IImage) =>
  image?.data
    ? `data:${image.contentType};${image.encoding},${image.data}`
    : require("../assets/images/slalom-logo-theme-default.svg");
